import { render, staticRenderFns } from "./solicitudAfiliacion.vue?vue&type=template&id=3af89a99"
import script from "./solicitudAfiliacion.vue?vue&type=script&lang=js"
export * from "./solicitudAfiliacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports